var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/archive-book"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-book"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 17.0625H6C3.2625 17.0625 1.6875 15.4875 1.6875 12.75V5.25C1.6875 2.5125 3.2625 0.9375 6 0.9375H12C14.7375 0.9375 16.3125 2.5125 16.3125 5.25V12.75C16.3125 15.4875 14.7375 17.0625 12 17.0625ZM6 2.0625C3.855 2.0625 2.8125 3.105 2.8125 5.25V12.75C2.8125 14.895 3.855 15.9375 6 15.9375H12C14.145 15.9375 15.1875 14.895 15.1875 12.75V5.25C15.1875 3.105 14.145 2.0625 12 2.0625H6Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.75 8.33249C6.6225 8.33249 6.495 8.31001 6.375 8.25751C6.03 8.10751 5.8125 7.77 5.8125 7.4025V1.5C5.8125 1.1925 6.0675 0.9375 6.375 0.9375H11.625C11.9325 0.9375 12.1875 1.1925 12.1875 1.5V7.39499C12.1875 7.76999 11.97 8.1075 11.625 8.25C11.2875 8.4 10.89 8.33251 10.6125 8.07751L9 6.59999L7.38748 8.08502C7.20748 8.25002 6.9825 8.33249 6.75 8.33249ZM9 5.40752C9.225 5.40752 9.45748 5.48998 9.63748 5.65498L11.0625 6.96748V2.0625H6.9375V6.96748L8.36252 5.65498C8.54252 5.48998 8.775 5.40752 9 5.40752Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.125 11.0625H9.9375C9.63 11.0625 9.375 10.8075 9.375 10.5C9.375 10.1925 9.63 9.9375 9.9375 9.9375H13.125C13.4325 9.9375 13.6875 10.1925 13.6875 10.5C13.6875 10.8075 13.4325 11.0625 13.125 11.0625Z",
    fill: "#0A5EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.125 14.0625H6.75C6.4425 14.0625 6.1875 13.8075 6.1875 13.5C6.1875 13.1925 6.4425 12.9375 6.75 12.9375H13.125C13.4325 12.9375 13.6875 13.1925 13.6875 13.5C13.6875 13.8075 13.4325 14.0625 13.125 14.0625Z",
    fill: "#0A5EF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.20e53d94568bdfef6b58be3355c9f71a.svg";
export { ForwardRef as ReactComponent };